import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { APP_CONST, SportsLobbyProviders } from "../config/const";
import { Button, Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import ModalWrapper from "./ModalWrapper";
import GamesSearchModal from "../views/components/GamesSearchModal";
import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";
import ThemeSelector from "../views/components/ThemeSelector";
import Top from "../assets/images/icons/header/Top.webp";
import Sports from "../assets/images/icons/header/Sports.webp";
import Esports from "../assets/images/icons/header/Esports.webp";
import Casino from "../assets/images/icons/header/Casino.webp";
import Slots from "../assets/images/icons/header/Slots.webp";
import BrandGame from "../assets/images/icons/header/BrandGame.webp";
import Logo from "../assets/images/logo.png";

const headerPages = [
  "home",
  "sports-lobby/ig_pixel",
  "igPixel",
  "sports1",
  "casinogames",
  "livecasino",
  "livegames",
  "casinos",
  "aviator",
  "evolution",
  "ezugi",
  "supernowa",
  "vivo",
  "xpg",
  "worldcasino",
  "qtech",
  "atlas-lobby",
  "/",
  "spmsports",
];

const menuItems = [
  { name: "Top", path: "/", activeKey: "/" },
  {
    name: "Sports",
    path: `/sports-lobby/${SportsLobbyProviders.IgPixel}`,
    activeKey: "igPixel",
  },
  {
    name: "Esports",
    path: `/sports-lobby/${SportsLobbyProviders.IgPixel}?slug=pre-match/95`,
    activeKey: "igPixel",
  },
  { name: "Casino", path: "/casinos", activeKey: "casinos" },
  { name: "Slots", path: "/casinogames", activeKey: "casinogames" },
  { name: "Yildiztop", path: "/brand-games", activeKey: "brand-games" },
  // { name: "SPM Sports", path: "/spmsports", activeKey: "spmsports" },
  // { name: "Exchange", path: "/sports/Cricket", activeKey: "sports1" },
  // { name: "Live-Casino", path: "/livecasino", activeKey: "livecasino" },
  // { name: "Aviator", path: "casino/spribe/aviator", activeKey: "aviator" },
  // { name: "Live-games", path: "/livegames", activeKey: "livegames" },
];
const menuItemsMob = [
  { name: "Top", path: "/", activeKey: "home", icon: Top },
  {
    name: "Sports",
    path: `/sports-lobby/${SportsLobbyProviders.IgPixel}`,
    activeKey: "igPixel",
    icon: Sports,
  },
  {
    name: "Esports",
    path: `/sports-lobby/${SportsLobbyProviders.IgPixel}?slug=pre-match/95`,
    activeKey: "",
    icon: Esports,
  },
  { name: "Casino", path: "/casinos", activeKey: "casinos", icon: Casino },
  {
    name: "Slots",
    path: "/casinogames",
    activeKey: "casinogames",
    icon: Slots,
  },
  {
    name: "Yildiztop",
    path: "/brand-games",
    activeKey: "brand-games",
    icon: BrandGame,
  },
];
const providers = [
  { name: "Evolution", path: "/casino/evolution", activeKey: "evolution" },
  { name: "Ezugi", path: "/casino/ezugi", activeKey: "ezugi" },
  { name: "Supernowa", path: "/casino/supernowa", activeKey: "supernowa" },
  { name: "Vivo", path: "/casino/vivo", activeKey: "vivo" },
  { name: "XPG", path: "/casino/xpg", activeKey: "xpg" },
  // {
  //   name: "Worldcasino",
  //   path: "/casino/worldcasino",
  //   activeKey: "worldcasino",
  // },
  { name: "Qtech", path: "/casino/qtech", activeKey: "qtech" },
  // {
  //   name: "Pragmatic Play",
  //   path: "/pragmaticplay",
  //   activeKey: "pragmaticplay",
  // },
  { name: "Aura", path: "/aura-games", activeKey: "aura" },
  // { name: "ALT Gaming", path: "/gap/jiliGaming", activeKey: "gap" },
  { name: "Vimplay", path: "/vimplay", activeKey: "vimplay" },
];

const Header = () => {
  const { appDetails } = useSelector((state) => state.app);
  const [showAuthModals, setShowAuthModals] = useState(false);
  const [defaultModal, setDefaultModal] = useState("login");
  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);

  const handleModalShow = (modalName) => {
    setShowAuthModals(true);
    setDefaultModal(modalName);
  };

  useEffect(() => {
    const matchedValue = headerPages.find((f) =>
      location?.pathname.includes(f),
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  // Header SubMenu active class feature
  const isMenuItemActive = (item) => {
    const { pathname, search } = location;

    // for top tab
    if (item.activeKey === "home") {
      return pathname === "/home";
    }

    // Sports & Esports special handling
    if (pathname.startsWith("/sports-lobby/ig_pixel")) {
      if (search && item.name === "Esports") return true;
      if (!search && item.name === "Sports") return true;
      return false;
    }

    // Default behavior
    return pathname === item.path;
  };

  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      if (currentScrollTop > lastScrollTop && currentScrollTop > 0) {
        // Scrolling down
        setIsSticky(true);
      } else if (currentScrollTop <= 0) {
        // Remove sticky class when scrolled all the way up
        setIsSticky(false);
      }
      setLastScrollTop(currentScrollTop);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]);

  const [isproviderActive, setIsproviderActive] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const inlineStyle = isproviderActive ? { overflowX: "clip" } : {};

  const handleProvidersClick = () => {
    const isMobile = window.innerWidth < 992;

    if (isMobile) {
      setShowModal(true);
      document.body.classList.add("modal-providers");
      document.documentElement.style.overflow = "hidden";
    } else {
      setIsproviderActive(!isproviderActive);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    document.body.classList.remove("modal-providers");
    document.documentElement.style.overflow = "auto";
  };

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  const [time, setTime] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();

      const localTime = new Intl.DateTimeFormat("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }).format(now);

      setTime(localTime);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}

      <header className="header beforeheader">
        <div className="top_head">
          <div className="inner-box">
            <div className="left-section">
              <div className="time-zone d-md-none">{time}</div>

              <div className="logo">
                <a href="/">
                  <img src={appDetails?.LOGO_URL} alt="Logo" height={60} />
                  {/* <img src={Logo} alt="Logo" /> */}
                </a>
              </div>

              <GamesSearchModal />
            </div>
            <div className="right-section">
              <div className="d-none d-md-block">
                <ThemeSelector />
              </div>

              <Button
                variant=""
                onClick={() => {
                  handleModalShow(APP_CONST.AUTH_MODAL.REGISTER);
                }}
                className="btn_signup"
              >
                Registration
              </Button>
              <Button
                variant=""
                onClick={() => {
                  handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                }}
                className="btn_signin"
              >
                Log In
              </Button>

              <div className="time-zone d-none d-md-block">{time}</div>
            </div>
          </div>
        </div>

        <div
          className={`bottom_head d-none d-md-block ${
            isSticky ? "sticky" : ""
          }`}
        >
          <div className="inner-box">
            <div className="head-links">
              <ul style={inlineStyle}>
                {menuItems.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.path}
                      className={`
                       ${isMenuItemActive(item) ? "active" : ""}
                      ${item.name === "Aviator" ? "game-logo" : ""}
                    `}
                    >
                      <span>
                        {item.isLogo ? (
                          <img src={item.logo} alt={item.name} />
                        ) : (
                          item.name
                        )}
                      </span>
                    </a>
                  </li>
                ))}
                {/* <li className="providers">
                  <a href="javascript:void(0)" onClick={handleProvidersClick}>
                    <span>Games by provider</span>
                  </a>
                  <ul
                    className={`providers-games d-none d-md-flex ${
                      isproviderActive ? "active" : ""
                    }`}
                  >
                    {providers.map((provider) => (
                      <li key={provider.name}>
                        <a
                          href={provider.path}
                          className={
                            activePage === provider.activeKey ? "active" : ""
                          }
                        >
                          <span>{provider.name}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </li> */}
                {/* <li className="providers">
                  <LanguageChange />
                </li> */}
                {/* <li className="providers">
                  <a
                    href="/atlas-lobby"
                    className={activePage === "atlas-lobby" ? "active" : ""}
                  >
                    <span>Sportsbook 2</span>
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="bottom_head d-md-none">
          <div className="head-links">
            <ul>
              {menuItemsMob.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.path}
                    className={`
                    ${isMenuItemActive(item) ? "active" : ""}
                  `}
                  >
                    <img src={item.icon} alt={item.name} />
                    <span>{item.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Modal
          className="providers-list"
          show={showModal}
          onHide={handleModalClose}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Body>
            <div className="providers-link">
              <ul>
                {providers.map((provider) => (
                  <li key={provider.name}>
                    <a
                      href={provider.path}
                      className={
                        activePage === provider.activeKey ? "active" : ""
                      }
                    >
                      <span>{provider.name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Modal.Body>
        </Modal>

        {showAuthModals && (
          <ModalWrapper
            defaultShow={defaultModal}
            handleClose={setShowAuthModals}
          />
        )}
      </header>
    </>
  );
};

export default Header;
